export default "__VITE_ASSET__ChEin84c__"